import React, { useEffect, useState } from "react";
import MaterialBox from "../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialInput from "../../../../components/MaterialInput";
import {
  CardContent,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Switch,
} from "@mui/material";
import MaterialButton from "../../../../components/MaterialButton";
import { useNavigate } from "react-router-dom";
import MaterialSelect from "../../../../components/MasterSelect";
import { fetchData } from "../../../../services";
import { useLoading } from "../../../../components/Loading";
import DropDownConfig from "../../../Utils/DropDownConfig";

export const GeneralCoverageForm = ({ onsubmit, editCoverageData }) => {
  const navigate = useNavigate();
  const [coverageData, setCoverageData] = useState({
    // coverage information
    name: "",
    description: "",
    coverageType: "",
    productId: "",
    policyTypeId: "",
    autoApply: true,
    mandatory: true,
    active: true,

    // coverage information status
    nameStatus: "unchecked",
    descriptionStatus: "unchecked",
    coverageTypeStatus: "unchecked",
    productIdStatus: "unchecked",
    policyTypeIdStatus: "unchecked",
  });


  const [coverageTypeOptions, setCoverageTypeOptions] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [policyTypeOptions, setPolicyTypeOptions] = useState([]);
  const {setCircleLoading} = useLoading();

  useEffect(() => {
    if (editCoverageData) {
      setCoverageData(editCoverageData);
    }
  }, [editCoverageData]);

  //dropdown apis
    useEffect(() => {
  
      //dropdown apis for form
      const fetchDropdowns = async () => {
        setCircleLoading(true);
        try {
        const [productResponse, policyTypeResponse, coverageResponse] = await Promise.all([
          fetchData(`/reference/general/key-value-store?dropdown=true&code=${DropDownConfig?.generalProduct}`),  //code passing for product
          fetchData(`/reference/general/key-value-store?dropdown=true&code=${DropDownConfig?.generalPolicyType}`), //code passing for policy type
          fetchData(`/reference/general/key-value-store?dropdown=true&code=${DropDownConfig?.generalCoverageType}`)  //code passing for coverage type
        ]);
  
          if (productResponse?.success) {
            setProductOptions(
              productResponse.data?.items?.map((item) => ({
                value: item.id,
                label: item.keyName,
              })) || []
            );
          }
  
          if (policyTypeResponse?.success) {
            setPolicyTypeOptions(
              policyTypeResponse.data?.items?.map((item) => ({
                value: item.id,
                label: item.keyName,
              })) || []
            );
          }

          if(coverageResponse?.success){
            setCoverageTypeOptions(
              coverageResponse.data?.items?.map((item) => ({
                value: item.id,
                label: item.keyName,
              })) || []
            );
          }
        } catch (error) {
          console.error("Error fetching dropdown data:", error);
        } finally {
          setCircleLoading(false);
        }
      };
  
      fetchDropdowns();
    }, []);

  const handleCoverageDataChange = (event, selectEvent) => {
    let coverageState = { ...coverageData };

    const changeAllowed = true;

        if(event?.target === undefined && selectEvent){
      switch(selectEvent.name){
        case "productId": {
            const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,100})$");

            if (alphaNLenghthRegex.test(event?.trim?.())) {
            coverageState[selectEvent.name + "Status"] = "success";
            } else {
            coverageState[selectEvent.name + "Status"] =
                event === "" ? "unchecked" : "error";
            }

            break;
        }

        case "policyTypeId": {
            const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,100})$");

            if (alphaNLenghthRegex.test(event?.trim?.())) {
            coverageState[selectEvent.name + "Status"] = "success";
            } else {
            coverageState[selectEvent.name + "Status"] =
                event === "" ? "unchecked" : "error";
            }

            break;
        }

        case "coverageType": {
            const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,100})$");

            if (alphaNLenghthRegex.test(event?.trim?.())) {
            coverageState[selectEvent.name + "Status"] = "success";
            } else {
            coverageState[selectEvent.name + "Status"] =
                event === "" ? "unchecked" : "error";
            }

            break;
        }
            
        default: {
            
            coverageState[selectEvent.name] = event;
            coverageState[selectEvent.name + "Status"] = event ? "success" : "unchecked";
            break;
        }
      }
      coverageState[selectEvent.name] = event;
    }
    else if (event) {
      switch (event.target.name) {
        case "name":
          {
            const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,40})$");

            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              coverageState[event.target.name + "Status"] = "success";
            } else {
              coverageState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "description":
          {
            const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,100})$");

            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              coverageState[event.target.name + "Status"] = "success";
            } else {
              coverageState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "autoApply":
          {
            const value = event.target.value;
            coverageState[event.target.name] = value;
          }
          break;

        case "mandatory":
          {
            const value = event.target.value;
            coverageState[event.target.name] = value;
          }
          break;

        case "active":
          {
            const value = event.target.value;
            coverageState[event.target.name] = value;
          }
          break;

        default:
          break;
      }

      if (changeAllowed) {
        coverageState[event.target.name] = event.target.value;
      }
    }
    setCoverageData(coverageState);
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      coverageData.nameStatus === "success" &&
      coverageData.coverageTypeStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleSubmit = () => {
    if (checkAllFields()) {
      onsubmit(coverageData);
    }
  };

  return (
    <div>
      <CardContent sx={{ minHeight: "65vh" }}>
        <MaterialBox>
          <Grid container spacing={1}>
            <Grid size={{ xs: 12, sm: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Coverage Name*
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="name"
                placeholder="eg. coverage name"
                value={coverageData.name}
                onChange={handleCoverageDataChange}
                error={coverageData.nameStatus === "error" ? true : false}
                success={coverageData.nameStatus === "success" ? true : false}
              />
              {coverageData.nameStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Name should be maximum 40 characters long and can contain
                    only alphabets
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Coverage Type*
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="coverageType"
                value={coverageData.coverageType}
                customStyles={{ optionPadding: 20 }}
                onChange={handleCoverageDataChange} //selectedValue, event
                options={coverageTypeOptions?.map((value) => {
                  return {
                    value: value.value,
                    label: value.label,
                  };
                })}
                error={
                  coverageData.coverageTypeStatus === "error" ? true : false
                }
                success={
                  coverageData.coverageTypeStatus === "success" ? true : false
                }
                isClearable
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Product*
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="productId"
                value={coverageData.productId}
                options={productOptions}
                onChange={handleCoverageDataChange}
                error={coverageData.productIdStatus === "error" ? true : false}
                success={
                  coverageData.productIdStatus === "success" ? true : false
                }
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Policy Type*
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="policyTypeId"
                value={coverageData.policyTypeId}
                options={policyTypeOptions}
                onChange={handleCoverageDataChange}
                error={coverageData.policyTypeIdStatus === "error" ? true : false}
                success={
                  coverageData.policyTypeIdStatus === "success" ? true : false
                }
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Description
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="description"
                placeholder="eg. coverage description"
                value={coverageData.description}
                onChange={handleCoverageDataChange}
                error={
                  coverageData.descriptionStatus === "error" ? true : false
                }
                success={
                  coverageData.descriptionStatus === "success" ? true : false
                }
                multiline
                rows={3}
              />
              {coverageData.descriptionStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Description should be maximum 100 characters long
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>

            <Grid size={{ xs: 12, sm: 2 }}>
              <MaterialBox>
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Auto Apply
                </MaterialTypography>
              </MaterialBox>
              <FormControlLabel
                control={
                  <Switch
                    name="autoApply"
                    checked={coverageData.autoApply}
                    onChange={(event) =>
                      handleCoverageDataChange({
                        target: {
                          name: "autoApply",
                          value: event.target.checked,
                        },
                      })
                    }
                    color="primary"
                  />
                }
                label={
                  <MaterialTypography variant="caption" fontWeight="bold">
                    {coverageData?.autoApply ? "Yes" : "No"}
                  </MaterialTypography>
                }
                sx={{ marginLeft: 0 }}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 2 }}>
              <MaterialBox>
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Mandatory
                </MaterialTypography>
              </MaterialBox>
              <FormControlLabel
                control={
                  <Switch
                    name="mandatory"
                    checked={coverageData.mandatory}
                    onChange={(event) =>
                      handleCoverageDataChange({
                        target: {
                          name: "mandatory",
                          value: event.target.checked,
                        },
                      })
                    }
                    color="primary"
                  />
                }
                label={
                  <MaterialTypography variant="caption" fontWeight="bold">
                    {coverageData?.mandatory ? "Yes" : "No"}
                  </MaterialTypography>
                }
                sx={{ marginLeft: 0 }}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 2 }}>
              <MaterialBox>
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Active
                </MaterialTypography>
              </MaterialBox>
              <FormControlLabel
                control={
                  <Switch
                    name="active"
                    checked={coverageData.active}
                    onChange={(event) =>
                      handleCoverageDataChange({
                        target: {
                          name: "active",
                          value: event.target.checked,
                        },
                      })
                    }
                    color="primary"
                  />
                }
                label={
                  <MaterialTypography variant="caption" fontWeight="bold">
                    {coverageData?.active ? "Yes" : "No"}
                  </MaterialTypography>
                }
                sx={{ marginLeft: 0 }}
              />
            </Grid>
          </Grid>
        </MaterialBox>
      </CardContent>
      <MaterialBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <MaterialButton
          sx={{ m: 2 }}
          variant="outlined"
          color="dark"
          onClick={() => {
            navigate("/general-master/general-coverage");
          }}
        >
          Cancel
        </MaterialButton>
        <MaterialButton
          sx={{ m: 2 }}
          variant="gradient"
          color="dark"
          disabled={!checkAllFields()}
          onClick={handleSubmit}
        >
          Submit
        </MaterialButton>
      </MaterialBox>
    </div>
  );
};
